import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ToastrService from '@/shared/services/ToastrService';
import intlShape from '@/shared/utils/intlShape';
import AutoComplete from '@/shared/components/input/select/AutoComplete';
import OkCancelModal from '@/shared/components/OkCancelModal';
import messages from '../documentMessages';

export default class ChangeDocumentTypeModal extends Component {
  state = {
    documentType: undefined,
  };

  static propTypes = {
    show: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    cannotBeChangedTo: PropTypes.arrayOf(PropTypes.number).isRequired,
    documentTypes: PropTypes.arrayOf({}).isRequired,
  };

  static defaultProps = {};

  onSave = () => {
    const { documentType } = this.state;
    const { onSave, intl } = this.props;
    if (!documentType) {
      ToastrService.error(intl.formatMessage(messages.InvalidType));
      return;
    }
    return onSave({ documentType });
  };

  closeModal = () => {
    const { onClose } = this.props;
    onClose();
  };

  render() {
    const { show, intl, cannotBeChangedTo, documentTypes } = this.props;
    const { documentType } = this.state;
    if (!show) return null;

    const canBeChangedToDocumentTypes = !cannotBeChangedTo
      ? []
      : documentTypes.filter(x => !cannotBeChangedTo.includes(x.id));

    const selectedDocumentType = documentTypes
      .map(x => ({ key: x.id, label: x.label }))
      .find(x => x.key === documentType);

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.ChangeDocumentType)}
        show={show}
        onClose={this.closeModal}
        disabled={false}
        onSave={() => this.onSave()}
      >
        <div className="form-horizontal">
          <div>
            <div className="form-group">
              <label className="control-label col-md-3">
                <FormattedMessage {...messages.Type} />
              </label>
              <div className="col-md-9">
                <AutoComplete
                  items={canBeChangedToDocumentTypes}
                  placeholder={intl.formatMessage(messages.StartTypingToSearch)}
                  onChange={item => this.setState({ documentType: item?.id })}
                  mode="edit"
                  value={selectedDocumentType}
                  showAll
                  required
                />
              </div>
            </div>
          </div>
        </div>
      </OkCancelModal>
    );
  }
}
